import { get, writable } from "svelte/store";
import { getDistance } from "geolib";
import journey, { journeySubscribeThrottled } from "./journey.js";
import { classifieds as classifiedsAt } from "../api/api.js";
import windows from "./windows.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 1500;

function createClassifiedsStore() {
    const store = writable({
        all: [],
        indexForCurrent: undefined,
        isLoading: false
    });

    const { subscribe, update } = store;

    let lastUpdatedAt;

    function updateClassifieds(location) {
        lastUpdatedAt = location;

        update((state) => ({
            ...state,
            isLoading: true
        }));

        classifiedsAt(location)
            .then(({ classifieds }) => {
                if (classifieds) {
                    update((state) => ({
                        ...state,
                        all: [...state.all, classifieds],
                        indexForCurrent: state.isPaused
                            ? Number.isFinite(state.indexForCurrent)
                                ? state.indexForCurrent
                                : state.all.length
                            : state.all.length,
                        isLoading: false
                    }));
                } else {
                    update((state) => ({
                        ...state,
                        isLoading: false
                    }));
                }
            })
            .catch((error) => {
                console.warn("failed to fetch classifieds", error.message);

                update((state) => ({
                    ...state,
                    isLoading: false
                }));
            });
    }

    journeySubscribeThrottled(12000, ({ location }) => {
        const shouldUpdate =
            location &&
            (lastUpdatedAt === undefined ||
                getDistance(lastUpdatedAt, location) >
                    MINIMUM_DISTANCE_INTERVAL_METERS) &&
            windows.isOpen("classifieds");

        if (!shouldUpdate) {
            return;
        }

        updateClassifieds(location);
    });

    windows.onOpen("classifieds", function didOpenWindow() {
        const shouldUpdate = get(store).all.length === 0;

        if (shouldUpdate) {
            updateClassifieds(get(journey).location);
        }
    });

    return {
        subscribe,

        previous() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.max(state.indexForCurrent - 1, 0)
            }));
        },

        next() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.min(
                    state.indexForCurrent + 1,
                    state.all.length - 1
                )
            }));
        },

        pause() {
            update((state) => ({
                ...state,
                isPaused: true
            }));
        },

        resume() {
            update((state) => ({
                ...state,
                isPaused: false
            }));
        }
    };
}

const classifieds = createClassifiedsStore();

export default classifieds;
